import React from "react";
import { Link } from "react-router-dom";
import { FlaskConical } from "lucide-react";
import { useSiteContent } from "@/lib/siteContent";

const Links = ({ items, testid }) => (
  <ul className="space-y-2 text-sm" data-testid={testid}>
    {(items || []).map((l) => <li key={l.url + l.ad}>{/^https?:/.test(l.url) ? <a href={l.url} className="hover:text-teal-300">{l.ad}</a> : <Link to={l.url} className="hover:text-teal-300">{l.ad}</Link>}</li>)}
  </ul>
);

export default function Footer() {
  const sc = useSiteContent();
  return (
    <footer className="bg-slate-900 text-slate-300 mt-20">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 py-12 grid grid-cols-1 md:grid-cols-4 gap-8">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2.5 mb-4">
            <div className="w-9 h-9 rounded-lg bg-teal-500 flex items-center justify-center">
              <FlaskConical className="w-5 h-5 text-white" />
            </div>
            <div className="font-head font-bold text-xl text-white">MOLAR KİMYA</div>
          </div>
          <p className="text-sm text-slate-400 max-w-md leading-relaxed">
            2005'ten bu yana kimya sektöründe hizmet veren Molar Kimya, laboratuvar ürünleri ve
            gıda hammaddelerini tek platformda buluşturur. Üretici değil; tedarikçi ve dağıtıcıyız.
          </p>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-3 text-sm">Platform</h4>
          <Links items={sc?.footer_urunler} testid="footer-links-platform" />
        </div>
        <div>
          <h4 className="text-white font-semibold mb-3 text-sm">Kurumsal</h4>
          <Links items={sc?.footer_kurumsal} testid="footer-links-kurumsal" />
          {sc?.calisma_saatleri && <p className="text-xs text-slate-500 mt-3 whitespace-pre-line" data-testid="footer-hours">{sc.calisma_saatleri}</p>}
        </div>
      </div>
      <div className="border-t border-slate-800">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 py-4 text-xs text-slate-500 flex flex-wrap justify-between gap-2">
          <span>© {new Date().getFullYear()} MOLAR KİMYA GIDA SAN ve TİC A.Ş</span>
          <span>
            SARIGÜLLÜK MAH. 61041 SK. SEDEF APT. NO: 12 A ŞEHİTKAMİL / GAZİANTEP ·{" "}
            <a href="tel:+905332727126" className="hover:text-teal-300" data-testid="footer-phone-link">0533 272 71 26</a> ·{" "}
            <a href="mailto:molarkimya@molarkimya.com" className="hover:text-teal-300" data-testid="footer-email-link">molarkimya@molarkimya.com</a>
          </span>
        </div>
      </div>
    </footer>
  );
}
